export const url = {
  type: "string",
  minLength: 1,
  maxLength: 2 * 1024
};
export const anyUrl = {
  ...url,
  minLength: 0
};
